module.exports = __webpack_public_path__ + "7b7a3c00f68a8874039faf632b3b71d4.svg";